// lib imports
import React, { FunctionComponent } from 'react';
import { object, string } from 'yup';
import { FormikHelpers, Formik, FormikProps, Field } from 'formik';
import { Grid, Button } from '@inplayer-org/inplayer-ui';

// utils
import isEmpty from 'lodash/isEmpty';

// components
import Input from 'components/Fields/Input';
import FieldError from 'components/Fields/FieldError';
import { QuickAddData } from 'pages/MerchantPages/Assets/assetTypes';
import IntegrationMessage from '../IntegrationMessage';

const { Container, Cell } = Grid;

interface FormValues {
  videoId: string;
}

interface OwnProps {
  keys: any;
  onSubmit: (data: QuickAddData) => any;
  onBackButtonClick: () => void;
}

type Props = OwnProps;

const validationSchema = object().shape({
  videoId: string().required('*Required'),
});

const BrightcoveQuickAdd: FunctionComponent<Props> = ({ onSubmit, keys, onBackButtonClick }) => {
  const initialValues = { videoId: '' };

  const onFormSubmit = async (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    await onSubmit(values);
    setSubmitting(false);
  };

  const isIntegrated: boolean = keys && !isEmpty(keys);

  return isIntegrated ? (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={onFormSubmit}
      >
        {({ handleSubmit, isSubmitting, isValid }: FormikProps<FormValues>) => (
          <form onSubmit={handleSubmit}>
            <Container columns={3} rowGap="2rem">
              <Cell width={3}>
                <Field
                  tag="text_input_brightcove_video_id"
                  name="videoId"
                  type="text"
                  component={Input}
                  label="Video ID"
                />
                <FieldError name="videoId" />
              </Cell>
              <Cell width={1}>
                <Button
                  tag="button_back"
                  fullWidth
                  buttonModifiers={['buttonLink']}
                  onClick={onBackButtonClick}
                  type="button"
                >
                  Back
                </Button>
              </Cell>
              <Cell width={1} left={3}>
                <Button
                  tag="button_save"
                  fullWidth
                  type="submit"
                  disabled={isSubmitting || !isValid}
                  buttonModifiers={['buttonPrimary']}
                >
                  Save
                </Button>
              </Cell>
            </Container>
          </form>
        )}
      </Formik>
    </>
  ) : (
    <IntegrationMessage ovpType="brightcove" />
  );
};

export default BrightcoveQuickAdd;
